module.exports = "https://syscdn.233leyuan.com/fw/activemodal/1625144333412/static/img/four.3213fce9.jpg";